import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import Footer from '../../components/Footer';
import ContactMain from './ContactMain';

const Contact = () => {
  return (
    <>
      <HeaderSeven />

      <ContactMain />

      <Footer />
    </>
  );
};

export default Contact;
